import script from "./AperturePhotometryConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./AperturePhotometryConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./AperturePhotometryConfiguration.vue?vue&type=style&index=0&id=70859c88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70859c88"]])

export default __exports__